import type { MergeFn } from "../events/DresonRuleBatch";

/**
 *
 *
 *
 */
export const mergeDresonRuleChanges: MergeFn = (changes) => {
  return changes[changes.length - 1];
};
